import * as jsxRuntime from "/Users/tosuke/ghq/github.com/tosuke-lab/vite-ssr-practice/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment